import React from 'react';
import cx from 'classnames';
import styles from './Box.module.scss';

interface Props {
  title?: string;
  className?: string;
  isDisabled?: boolean;
}

const Box: React.FC<Props> = ({ title, children, className, isDisabled = false }) => {
  return (
    <div className={cx(styles.box, className, { [styles.disabled]: isDisabled })}>
      {title && <h3>{title}</h3>}
      {children}
    </div>
  );
};

export default Box;
